import { Flex, Skeleton } from '@chakra-ui/react';
import assert from 'assert';
import React from 'react';

import { useGetUserQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import { GSRouterSideBarTEMP } from './GSRouterSideBarTEMP';
import { CapitalProviderHeader } from 'capitalProvider/domains/page/ui/CapitalProviderHeader';
import 'borrower/borrower.scss';

// @jendevelops TODO: either consolidate with fremium eventually, or just outright delete
export const GSRouterTemplateTEMP: React.FC = ({ children }) => {
  const { data, loading } = useGetUserQuery();
  if (!data || loading) {
    return <Skeleton data-testid="loading-borrower-router" height="600px" />;
  }

  const { user } = data;
  assert(user, 'User expected to exist');

  return (
    <>
      <CapitalProviderHeader isDisabled />
      <Flex minH="95vh" grow={1}>
        <GSRouterSideBarTEMP />
        {children}
      </Flex>
    </>
  );
};
